import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
    // localStorage'dan başlangıç değerini al, yoksa EUR kullan
    const [selectedCurrency, setSelectedCurrency] = useState(() => 
        localStorage.getItem('selectedCurrency') || 'EUR'
    );
    const [exchangeRates, setExchangeRates] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchExchangeRates = async () => {
        try {
            const response = await axios.get('https://finans.truncgil.com/v4/today.json');
            setExchangeRates(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Döviz kurları çekilirken hata oluştu:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchExchangeRates();
        // Her 1 saatte bir kurları güncelle
        const interval = setInterval(fetchExchangeRates, 3600000);
        return () => clearInterval(interval);
    }, []);

    // Para birimi değiştiğinde localStorage'a kaydet ve sayfayı yenile
    const handleCurrencyChange = (currency) => {
        localStorage.setItem('selectedCurrency', currency);
        setSelectedCurrency(currency);
    };

    const convertPrice = (amount, fromCurrency = 'EUR') => {
        if (loading || !exchangeRates || !exchangeRates.Update_Date) {
            return amount;
        }

        try {
            if (fromCurrency === selectedCurrency) return amount;

            const baseEuro = amount / exchangeRates[fromCurrency];
            return baseEuro * exchangeRates[selectedCurrency];
        } catch (error) {
            console.error('Fiyat dönüştürme hatası:', error);
            return amount;
        }
    };

    const formatPrice = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: selectedCurrency
        }).format(amount);
    };

    return (
        <CurrencyContext.Provider value={{
            selectedCurrency,
            setSelectedCurrency: handleCurrencyChange, // setSelectedCurrency yerine handleCurrencyChange kullan
            exchangeRates,
            convertPrice,
            formatPrice,
            loading
        }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => useContext(CurrencyContext);